import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { FileWarning } from "lucide-react";

const fmtD = (iso) => (iso ? iso.split("-").reverse().join(".") : "");

export default function MissingReportsBanner() {
  const [missing, setMissing] = useState([]);

  useEffect(() => {
    api.get("/me/missing-reports").then((r) => setMissing(r.data?.missing || [])).catch(() => setMissing([]));
  }, []);

  if (missing.length === 0) return null;

  return (
    <div className="border-2 border-red-500 bg-red-50 rounded-lg p-4" data-testid="missing-reports-banner">
      <div className="flex items-center gap-2 mb-2">
        <FileWarning size={18} className="text-red-600" />
        <span className="font-bold text-red-800 text-sm">
          ⚠ Rapoarte de ore lipsă: {missing.length} — încarcă-le cât mai repede!
        </span>
      </div>
      <div className="space-y-1.5">
        {missing.map((m, i) => (
          <div key={i} className="bg-white border border-red-200 rounded-md px-3 py-1.5 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs" data-testid={`missing-report-${i}`}>
            <span className="font-bold text-zinc-900">{m.regie_name}</span>
            {m.type === "zi" ? (
              <span className="font-semibold text-red-700">📆 Raport ZILNIC lipsă pentru {fmtD(m.date)}</span>
            ) : (
              <span className="font-semibold text-red-700">📅 Raport SĂPTĂMÂNAL lipsă: {fmtD(m.week_start)} – {fmtD(m.week_end)}</span>
            )}
          </div>
        ))}
      </div>
      <p className="text-[11px] text-red-700 mt-2">
        Folosește butonul „Raport ore" de mai jos pentru a fotografia sau încărca raportul.
      </p>
    </div>
  );
}
